import { CSBNET_NAMESPACE_ID } from 'src/constants';
import {
  APPLICANT,
  SMARTMATCH_TYPE_LOAN_OFFICER,
  SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
  STATUS_SUBMITTED,
  STATUS_APPLICATION_APPROVED,
  STATUS_CLEAR_TO_CLOSE_COMPLETED,
  STATUS_DOCUMENTS_SIGNED,
  STATUS_LOAN_CLOSED,
  STATUS_FUNDING,
  STATUS_APPLICATION_STARTED,
  STATUS_WITHDRAW,
  STATUS_DECLINED,
  STATUS_APPROVED_NOT_ACCEPTED,
  STATUS_INVITATION_SENT,
  STATUS_PRE_APPROVAL,
} from 'src/services/constants';
import { USER_ONBOARD_ADMIN } from 'src/services/constants/accounts';
import {
  HOME_EQUITY,
  PURCHASE,
  REFINANCE,
  RESIDENTIAL_MORTGAGE,
  CONSTRUCTION_LOAN,
} from 'src/features/LoansHome/Products/constants';

const stageStarted = {
  name: STATUS_APPLICATION_STARTED,
  display_name: STATUS_APPLICATION_STARTED,
  order_id: 1,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_PRE_APPROVAL,
          display_name: STATUS_PRE_APPROVAL,
        },
        {
          name: STATUS_INVITATION_SENT,
          display_name: STATUS_INVITATION_SENT,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};

const stageStartedConstruction = {
  name: STATUS_APPLICATION_STARTED,
  display_name: STATUS_APPLICATION_STARTED,
  order_id: 1,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_INVITATION_SENT,
          display_name: STATUS_INVITATION_SENT,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};
const stageSubmitted = {
  name: STATUS_SUBMITTED,
  display_name: STATUS_SUBMITTED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_PRE_APPROVAL,
          display_name: STATUS_PRE_APPROVAL,
        },
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};

const stageSubmittedConstruction = {
  name: STATUS_SUBMITTED,
  display_name: STATUS_SUBMITTED,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};
const stagePreApproval = {
  name: STATUS_PRE_APPROVAL,
  display_name: STATUS_PRE_APPROVAL,
  order_id: 3,
  children: [
    {
      stages: [
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};

const stageApplicationApproved = {
  name: STATUS_APPLICATION_APPROVED,
  display_name: STATUS_APPLICATION_APPROVED,
  order_id: 4,
  children: [
    {
      stages: [
        {
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};
const stageDocumentsSigned = {
  name: STATUS_DOCUMENTS_SIGNED,
  display_name: STATUS_DOCUMENTS_SIGNED,
  order_id: 5,
  children: [
    {
      stages: [
        {
          name: STATUS_FUNDING,
          display_name: STATUS_FUNDING,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};
const stageFunding = {
  name: STATUS_FUNDING,
  display_name: STATUS_FUNDING,
  order_id: 6,
  children: [
    {
      stages: [
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
      ],
    },
  ],
};
const stageLoanClearToCloseCompleted = {
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  order_id: 7,
  children: [
    {
      stages: [
        {
          name: STATUS_DOCUMENTS_SIGNED,
          display_name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};

const stageLoanClosed = {
  name: STATUS_LOAN_CLOSED,
  display_name: STATUS_LOAN_CLOSED,
  order_id: 8,
  children: [],
};

const stageApprovedNotAccepted = {
  name: STATUS_APPROVED_NOT_ACCEPTED,
  display_name: STATUS_APPROVED_NOT_ACCEPTED,
  order_id: 9,
  children: [],
};
const stageWithdrawn = {
  name: STATUS_WITHDRAW,
  display_name: STATUS_WITHDRAW,
  order_id: 10,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_LOAN_CLOSED,
          display_name: STATUS_LOAN_CLOSED,
        },
      ],
    },
  ],
};

const stageDeclined = {
  name: STATUS_DECLINED,
  display_name: STATUS_DECLINED,
  order_id: 11,
  children: [
    {
      stages: [
        {
          name: STATUS_APPLICATION_STARTED,
          display_name: STATUS_APPLICATION_STARTED,
        },
      ],
    },
  ],
};

const stageDeclinedAdmin = {
  name: STATUS_DECLINED,
  display_name: STATUS_DECLINED,
  order_id: 12,
  children: [
    {
      stages: [
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_APPLICATION_STARTED,
          display_name: STATUS_APPLICATION_STARTED,
        },
      ],
    },
  ],
};

const stageInvitationSent = {
  name: STATUS_INVITATION_SENT,
  display_name: STATUS_INVITATION_SENT,
  order_id: 13,
  children: [],
};

const CSBNET_LOAN_STAGES_CONFIG = {
  id: '154878745215745754',
  namespace_id: CSBNET_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE],
  sub_loan_types: [PURCHASE, REFINANCE, HOME_EQUITY],
  stages: [
    stageStarted,
    stageSubmitted,
    stagePreApproval,
    stageApplicationApproved,
    stageDocumentsSigned,
    stageFunding,
    stageLoanClearToCloseCompleted,
    stageLoanClosed,
    stageApprovedNotAccepted,
    stageWithdrawn,
    stageDeclined,
    stageInvitationSent,
  ],
  roles: [SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER],
} as any;

const CSBNET_LOAN_STAGES_CONFIG_ADMIN = {
  id: '154878745215745754',
  namespace_id: CSBNET_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE],
  sub_loan_types: [PURCHASE, REFINANCE, HOME_EQUITY],
  stages: [
    stageStarted,
    stageSubmitted,
    stagePreApproval,
    stageApplicationApproved,
    stageDocumentsSigned,
    stageFunding,
    stageLoanClearToCloseCompleted,
    stageLoanClosed,
    stageApprovedNotAccepted,
    stageWithdrawn,
    stageDeclinedAdmin,
    stageInvitationSent,
  ],
  roles: [USER_ONBOARD_ADMIN],
} as any;

const CSBNET_LOAN_STAGES_CONSTRUCTION_CONFIG = {
  id: '154878745215745754',
  namespace_id: CSBNET_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE],
  sub_loan_types: [CONSTRUCTION_LOAN],
  stages: [
    stageStartedConstruction,
    stageSubmittedConstruction,
    stageApplicationApproved,
    stageDocumentsSigned,
    stageFunding,
    stageLoanClearToCloseCompleted,
    stageLoanClosed,
    stageApprovedNotAccepted,
    stageWithdrawn,
    stageDeclined,
    stageInvitationSent,
  ],
  roles: [
    SMARTMATCH_TYPE_LOAN_OFFICER,
    SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
    USER_ONBOARD_ADMIN,
  ],
} as any;

const CSBNET_LOAN_STAGES_CONFIG_APPLICANT = {
  id: '154878745215745754',
  namespace_id: CSBNET_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE],
  sub_loan_types: [PURCHASE, REFINANCE, HOME_EQUITY],
  stages: [
    {
      name: STATUS_APPLICATION_STARTED,
      display_name: STATUS_APPLICATION_STARTED,
      order_id: 1,
      children: [
        {
          stages: [
            {
              name: STATUS_SUBMITTED,
              display_name: STATUS_SUBMITTED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_SUBMITTED,
      display_name: STATUS_SUBMITTED,
      order_id: 2,
      children: [
        {
          stages: [
            {
              name: STATUS_PRE_APPROVAL,
              display_name: STATUS_PRE_APPROVAL,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_PRE_APPROVAL,
      display_name: STATUS_PRE_APPROVAL,
      order_id: 3,
      children: [
        {
          stages: [
            {
              name: STATUS_APPLICATION_APPROVED,
              display_name: STATUS_APPLICATION_APPROVED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_APPLICATION_APPROVED,
      display_name: STATUS_APPLICATION_APPROVED,
      order_id: 4,
      children: [
        {
          stages: [
            {
              name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
              display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      order_id: 7,
      children: [
        {
          stages: [
            {
              name: STATUS_DOCUMENTS_SIGNED,
              display_name: STATUS_DOCUMENTS_SIGNED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_DOCUMENTS_SIGNED,
      display_name: STATUS_DOCUMENTS_SIGNED,
      order_id: 5,
      children: [
        {
          stages: [
            {
              name: STATUS_FUNDING,
              display_name: STATUS_FUNDING,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_FUNDING,
      display_name: STATUS_FUNDING,
      order_id: 6,
      children: [
        {
          stages: [
            {
              name: STATUS_LOAN_CLOSED,
              display_name: STATUS_LOAN_CLOSED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_LOAN_CLOSED,
      display_name: STATUS_LOAN_CLOSED,
      order_id: 8,
      children: [],
    },
  ],
  roles: [APPLICANT],
} as any;

const CSBNET_LOAN_STAGES_CONFIG_CONSTRUCTION_APPLICANT = {
  id: '154878745215745754',
  namespace_id: CSBNET_NAMESPACE_ID,
  loan_type: [RESIDENTIAL_MORTGAGE],
  sub_loan_types: [CONSTRUCTION_LOAN],
  stages: [
    {
      name: STATUS_APPLICATION_STARTED,
      display_name: STATUS_APPLICATION_STARTED,
      order_id: 1,
      children: [
        {
          stages: [
            {
              name: STATUS_SUBMITTED,
              display_name: STATUS_SUBMITTED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_SUBMITTED,
      display_name: STATUS_SUBMITTED,
      order_id: 2,
      children: [
        {
          stages: [
            {
              name: STATUS_APPLICATION_APPROVED,
              display_name: STATUS_APPLICATION_APPROVED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_APPLICATION_APPROVED,
      display_name: STATUS_APPLICATION_APPROVED,
      order_id: 4,
      children: [
        {
          stages: [
            {
              name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
              display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
      order_id: 7,
      children: [
        {
          stages: [
            {
              name: STATUS_DOCUMENTS_SIGNED,
              display_name: STATUS_DOCUMENTS_SIGNED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_DOCUMENTS_SIGNED,
      display_name: STATUS_DOCUMENTS_SIGNED,
      order_id: 5,
      children: [
        {
          stages: [
            {
              name: STATUS_FUNDING,
              display_name: STATUS_FUNDING,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_FUNDING,
      display_name: STATUS_FUNDING,
      order_id: 6,
      children: [
        {
          stages: [
            {
              name: STATUS_LOAN_CLOSED,
              display_name: STATUS_LOAN_CLOSED,
            },
          ],
        },
      ],
    },
    {
      name: STATUS_LOAN_CLOSED,
      display_name: STATUS_LOAN_CLOSED,
      order_id: 8,
      children: [],
    },
  ],
  roles: [APPLICANT],
} as any;

export const csbnetLoanStages = [
  CSBNET_LOAN_STAGES_CONFIG,
  CSBNET_LOAN_STAGES_CONSTRUCTION_CONFIG,
  CSBNET_LOAN_STAGES_CONFIG_APPLICANT,
  CSBNET_LOAN_STAGES_CONFIG_CONSTRUCTION_APPLICANT,
  CSBNET_LOAN_STAGES_CONFIG_ADMIN,
];
